import { createSxStyles } from "@common/createSxStyles";
import { assessmentsTableAddButtonContainer } from "../../assessmentsTableStyles";

export const useEntityAssessmentsTableStyles = () => {
    return createSxStyles({
        riskCell: {
            display: "inline-flex",
            alignItems: "center",
        },
        addButtonContainer: assessmentsTableAddButtonContainer,
    });
};
